import $ from "jquery";
import { API_HOST } from "../api_utils/index";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CustomQRCodePlugin = (editor, options) => {
  if (editor !== null && editor !== undefined) {
    //qr component
    editor.Blocks.add("custom_qr_code", {
      label: "QR Code",
      category: "Basic",
      select: true,
      media:
        '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 16 16"><path d="M2 2h4v4H2V2zm1 1v2h2V3H3zm8-1h4v4h-4V2zm1 1v2h2V3h-2zM2 11h4v4H2v-4zm1 1v2h2v-2H3zm5-7h1v2h-1V5zm2 0h1v1h-1V5zm-2 2h1v1h-1V7zm2 0h1v1h-1V7zm1 1h1v1h-1V8zm-3 1h1v1h-1V9zm2 0h1v1h-1V9zm2 0h1v3h-1V9zm-4 1h1v1h-1v-1zm2 1h1v1h-1v-1zm-1 1h1v1h-1v-1zm2 0h1v1h-1v-1zm2-8h1v1h-1V4zm0 2h1v1h-1V6zm0 6h1v2h-1v-2z"/></svg>',
      content: {
        type: "custom_qr_code",
      },
    });

    // editor.Blocks.add("qr_code_download_button_container", {
    //   label: "Download QR Code",
    //   category: "Basic",
    //   select: true,
    //   media:
    //     '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 16 16"><path d="M2 2h4v4H2V2zm1 1v2h2V3H3zm8-1h4v4h-4V2zm1 1v2h2V3h-2zM2 11h4v4H2v-4zm1 1v2h2v-2H3zm5-7h1v2h-1V5zm2 0h1v1h-1V5zm-2 2h1v1h-1V7zm2 0h1v1h-1V7zm1 1h1v1h-1V8zm-3 1h1v1h-1V9zm2 0h1v1h-1V9zm2 0h1v3h-1V9zm-4 1h1v1h-1v-1zm2 1h1v1h-1v-1zm-1 1h1v1h-1v-1zm2 0h1v1h-1v-1zm2-8h1v1h-1V4zm0 2h1v1h-1V6zm0 6h1v2h-1v-2z"/></svg>',
    //   content: {
    //     type: "qr_code_download_button_container",
    //   },
    // });

    const qrCodeScript = function (props) {
      console.log("this, props", this, props);

      let container = this;
      let stellarButton = container.getElementsByClassName("stellar-btn")[0];

      let qrCodes = document.getElementsByClassName("qr_code");
      let qrCodes1 = container.getElementsByClassName("qr_code")[0];
      console.log("QRCodes", qrCodes);
      console.log("QRCodes1", qrCodes1);

      //get the id from qrCodes1.id and find that id in qrCodes array object, connvert to array and get the index of that id.

      // Get the id from qrCodes1 div
      let divId = qrCodes1.getAttribute("id");
      console.log("ID from qrCodes1 div:", divId);

      // Convert HTMLCollection to array to use findIndex
      let qrCodesArray = Array.from(qrCodes);
      console.log("QRCodesArray", qrCodesArray);

      // Find the matching element and log just its id
      let matchingElement = qrCodesArray.find(
        (element) => element.id === divId
      );
      console.log(
        "Matching element's id:",
        matchingElement ? matchingElement.id : null
      );

      let matchingIndex = qrCodesArray.findIndex(
        (element) => element.id === divId
      );
      console.log("Index of matching element:", matchingIndex);

      function displayQR(props) {
        if (props.hideQR) {
          let qrEle = container.getElementsByClassName("qr_code")[0];
          qrEle.style.display = "none";
        } else {
          let qrEle = container.getElementsByClassName("qr_code")[0];
          qrEle.style.display = "block";
        }
      }

      // displayQR(props);

      // function initLib(props) {
      //   // let downloadQRButton = container
      //   //   ?.getElementsByClassName("qr_code_download_button_container")[0]
      //   //   ?.getElementsByClassName("qr_code_download_button")[0]; // Added [0] to get the first element

      //   let btnContainer = container
      //     ? container.getElementsByClassName(
      //         "qr_code_download_button_container"
      //       )[0]
      //     : container;
      //   let downloadQRButton = btnContainer
      //     ? btnContainer.getElementsByClassName("qr_code_download_button")[0]
      //     : container.getElementsByClassName("qr_code_download_button")[0];

      //   if (props.allowDownload) {
      //     console.log("Props and Button:", props, downloadQRButton);

      //     if (downloadQRButton) {
      //       downloadQRButton.onclick = function (event) {
      //         console.log("QR Download button clicked");
      //         const qrCodeDiv = container.getElementsByClassName("qr_code")[0];
      //         console.log("QR Code Div:", qrCodeDiv);

      //         try {
      //           const canvas = qrCodeDiv.getElementsByTagName("canvas")[0];
      //           console.log("Canvas:", canvas);

      //           if (canvas) {
      //             // Create a new canvas with the same dimensions
      //             const newCanvas = document.createElement("canvas");
      //             const ctx = newCanvas.getContext("2d");
      //             newCanvas.width = canvas.width;
      //             newCanvas.height = canvas.height;

      //             // Draw the original canvas content onto the new canvas
      //             ctx.fillStyle = "#ffffff"; // Set white background
      //             ctx.fillRect(0, 0, newCanvas.width, newCanvas.height);
      //             ctx.drawImage(canvas, 0, 0);

      //             // Get base64 data URL from the new canvas
      //             const imgData = newCanvas.toDataURL("image/png", 1.0);

      //             // Create download link with proper MIME type
      //             const link = document.createElement("a");
      //             link.href = imgData;
      //             link.download = "qrcode.png";

      //             // Trigger download immediately
      //             link.dispatchEvent(new MouseEvent("click"));
      //           } else {
      //             console.error("QR code canvas not found");
      //           }
      //         } catch (error) {
      //           console.error("Error generating QR code download:", error);
      //         }
      //       };
      //     }
      //   } else {
      //     if (downloadQRButton) {
      //       // Added check to ensure button exists
      //       downloadQRButton.onclick = null;
      //     }
      //   }
      // }

      function initLib(props) {
        if (stellarButton) {
          // Clear any previous event handlers to avoid duplication
          stellarButton.onclick = null;

          if (props.allowDownload) {
            console.log("Props and Button:", props, stellarButton);

            stellarButton.onclick = function (event) {
              event.preventDefault();
              console.log("Stellar button clicked");
              const qrCodeDiv = container.getElementsByClassName("qr_code")[0];
              console.log("QR Code Div:", qrCodeDiv);

              try {
                const canvas = qrCodeDiv.getElementsByTagName("canvas")[0];
                console.log("Canvas:", canvas);

                if (canvas) {
                  const newCanvas = document.createElement("canvas");
                  const ctx = newCanvas.getContext("2d");
                  newCanvas.width = canvas.width;
                  newCanvas.height = canvas.height;

                  ctx.fillStyle = "#ffffff";
                  ctx.fillRect(0, 0, newCanvas.width, newCanvas.height);
                  ctx.drawImage(canvas, 0, 0);

                  const imgData = newCanvas.toDataURL("image/png", 1.0);
                  const link = document.createElement("a");
                  link.href = imgData;
                  link.download = "qrcode.png";
                  link.dispatchEvent(new MouseEvent("click"));
                } else {
                  console.error("QR code canvas not found");
                }
              } catch (error) {
                console.error("Error generating QR code download:", error);
              }
            };
          } else {
            // Remove click functionality when allowDownload is false
            console.log("Download disabled");
            stellarButton.onclick = null;
          }
        }
      }

      const scriptId = `qrcode-script-${matchingIndex}`; // Changed to be unique per instance
      const oldScript = document.getElementById(scriptId);
      if (oldScript) oldScript.remove();

      const script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("id", scriptId);

      script.innerHTML = `
  window.initQRCode_${matchingIndex} = function() {  // Changed to be unique per instance
    if (typeof QRCode !== "undefined") {
      const container = document.querySelectorAll('.qr_code')[${matchingIndex}];
      console.log("###Container", container)
      if (container) {
        container.innerHTML = '';
        new QRCode(container, {
          text: ${JSON.stringify(props.content)},
          width: ${props.size},
          height: ${props.size},
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.${props.errorCorrection}
        });
      }
    }
  };
`;

      document.body.appendChild(script);

      // Load QRCode.js library
      const loadQRCode = () => {
        const qrcodeScript = document.createElement("script");
        qrcodeScript.setAttribute("type", "text/javascript");
        qrcodeScript.setAttribute(
          "src",
          "https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"
        );
        qrcodeScript.setAttribute("async", true);
        qrcodeScript.setAttribute("defer", true);
        qrcodeScript.onload = () => {
          window[`initQRCode_${matchingIndex}`]();
          initLib(props);
        };
        document.body.appendChild(qrcodeScript);
      };

      // Check if QRCode is already loaded
      if (!window.QRCode) {
        loadQRCode();
      } else {
        window[`initQRCode_${matchingIndex}`]();
        initLib(props);
      }
    };

    editor.DomComponents.addType("custom_qr_code", {
      model: {
        defaults: {
          tagName: "div",
          script: qrCodeScript,
          type: "custom_qr_code_container",
          content: "https://www.google.com",
          size: 200,
          errorCorrection: "H",
          hideQR: true,
          allowDownload: false,
          traits: [
            {
              type: "text",
              name: "content",
              label: "Content",
              placeholder: "Enter QR content",
              changeProp: true,
            },
            {
              type: "number",
              name: "size",
              label: "Size",
              min: 100,
              max: 1000,
              changeProp: true,
            },
            {
              type: "select",
              name: "errorCorrection",
              label: "Error Correction",
              options: [
                { value: "L", name: "Low (7%)" },
                { value: "M", name: "Medium (15%)" },
                { value: "Q", name: "Quartile (25%)" },
                { value: "H", name: "High (30%)" },
              ],
              changeProp: true,
            },
            {
              type: "checkbox",
              name: "hideQR",
              label: "Hide QR",
              changeProp: true,
            },
            {
              type: "checkbox",
              name: "allowDownload",
              label: "Allow Download",
              changeProp: true,
            },
          ],
          "script-props": [
            "content",
            "size",
            "errorCorrection",
            "hideQR",
            "allowDownload",
          ],
          changeProp: true,
          attributes: {
            class: "custom_qr_code_container",
          },
          "style-default": {
            width: "17vw",
            height: "auto",
            display: "flex",
            "flex-direction": "column",
            "justify-content": "center",
            "align-items": "center",
            "padding-bottom": "3vh",
          },
          style: {
            width: "17vw",
            height: "auto",
            display: "flex",
            "flex-direction": "column",
            "justify-content": "center",
            "align-items": "center",
            "padding-bottom": "3vh",
          },
          styles: `
            @media only screen and (max-width: 480px) {
          .custom_qr_code_container {
            width: 75vw;
            padding: 2.5vh;
          }
        }
      `,
          components: [
            {
              tagName: "div",
              type: "qr_code",
              attributes: {
                class: "qr_code",
              },
              "style-default": {
                width: "100%",
                height: "100%",
                "flex-shrink": "0",
                "flex-grow": "0",
              },
              style: {
                width: "100%",
                height: "100%",
                "flex-shrink": "0",
                "flex-grow": "0",
              },
              styles: `
                @media only screen and (max-width: 480px) {
              .qr_code {
                width: 70vw;
              }
            }
          `,
            },
          ],
        },

        init() {
          this.on("change:hideQR", this.displayQR);
        },

        displayQR() {
          let { hideQR } = this.props();
          let container = this;
          let qrEle = container.find(".qr_code")[0];
          let stellarButton = container.find(".stellar-btn")[0];

          console.log("this", this, qrEle);

          if (qrEle) {
            if (hideQR) {
              let existingStyles = qrEle.getStyle();

              qrEle.setStyle({
                ...existingStyles,
                display: "none",
              });
            } else {
              let existingStyles = qrEle.getStyle();

              qrEle.setStyle({
                ...existingStyles,
                display: "block",
              });

              console.log("@@@@@@HIde QR:", qrEle.getStyle());
            }
          }

          if (stellarButton) {
            if (hideQR) {
              let existingStylesButton = stellarButton.getStyle();

              stellarButton.setStyle({
                ...existingStylesButton,
                display: "none",
              });
            } else {
              let existingStylesButton = stellarButton.getStyle();

              stellarButton.setStyle({
                ...existingStylesButton,
                display: "block",
              });
            }
          }
        },
      },
    });

    // editor.DomComponents.addType("qr_code_download_button_container", {
    //   model: {
    //     defaults: {
    //       tagName: "div",
    //       type: "qr_code_download_button_container",
    //       attributes: {
    //         class: "qr_code_download_button_container",
    //       },

    //       components: [
    //         {
    //           tagName: "button",
    //           type: "qr_code_download_button",
    //           attributes: {
    //             class: "qr_code_download_button",
    //           },
    //           "style-default": {
    //             width: "max-content",
    //             "min-width": "120px", // Added minimum width
    //             "min-height": "35px", //Added minimum height
    //             padding: "0.7%",
    //             "border-radius": "10px",
    //             "background-color": "white",
    //             border: "2px solid red",
    //             color: "red",
    //             cursor: "pointer",
    //             display: "flex",
    //             "align-items": "center",
    //             "justify-content": "center",
    //             gap: "3%",
    //             "margin-top": "10px",
    //           },

    //           style: {
    //             width: "max-content",
    //             "min-width": "120px", // Added minimum width
    //             "min-height": "35px", //Added minimum height
    //             padding: "0.7%",
    //             "border-radius": "10px",
    //             "background-color": "white",
    //             border: "2px solid red",
    //             color: "red",
    //             cursor: "pointer",
    //             display: "flex",
    //             "align-items": "center",
    //             "justify-content": "center",
    //             gap: "3%",
    //             "margin-top": "10px",
    //           },
    //           components: [
    //             {
    //               tagName: "p",
    //               type: "text",
    //               editable: true,

    //               "style-default": {
    //                 margin: "auto",
    //                 "text-align": "left",
    //                 color: "inherit",
    //               },

    //               style: {
    //                 margin: "auto",
    //                 "text-align": "left",
    //                 color: "inherit",
    //               },

    //               components: {
    //                 type: "textnode",
    //                 content: "Download QR",
    //               },
    //             },
    //           ],
    //         },
    //       ],
    //     },
    //   },
    // });
  }
};

export default CustomQRCodePlugin;
